import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useCallback } from 'react';
import { useFormikContext, Field } from 'formik';
import { SimpleGrid, Stack, FormLabel, Box, RadioGroup, CheckboxGroup } from '@chakra-ui/react';
import { Toggle } from '../../Toggle/component.js';
import { Radio } from '../../Radio/component.js';
import { Checkbox } from '../../Checkbox/component.js';
import { OptionLabel } from '../../OptionLabel/component.js';
var _excluded = ["tooltip"],
    _excluded2 = ["label"];

var getGroup = function getGroup(type) {
  var groupTypes = {
    checkbox: CheckboxGroup,
    radio: RadioGroup,
    "switch": Box
  };
  return groupTypes[type];
};

var getInput = function getInput(type) {
  var inputTypes = {
    checkbox: Checkbox,
    radio: Radio,
    "switch": Toggle
  };
  return inputTypes[type];
};

var getAriaDescribedById = function getAriaDescribedById(option, name) {
  return option.helpText ? "".concat(name, "-").concat(option.value, "-helptext") : '';
};

var getVariant = function getVariant(card, stacked) {
  if (card) {
    return 'card';
  }

  if (stacked) {
    return 'stacked';
  }

  return 'default';
};

var OptionsGroup = function OptionsGroup(_ref) {
  var value = _ref.value,
      type = _ref.type,
      card = _ref.card,
      options = _ref.options,
      name = _ref.name,
      reversed = _ref.reversed,
      stacked = _ref.stacked,
      onChange = _ref.onChange,
      changeHandler = _ref.changeHandler;

  if (!useFormikContext) {
    throw Error('The <OptionsGroup /> component must be wrapped in a Formik context.  Did you mean to use the Core.SelectionControl instead?');
  }

  var Group = getGroup(type);
  var Input = getInput(type);
  var direction = stacked ? 'column' : 'row';
  var align = stacked ? 'center' : 'baseline';
  var setField = useCallback(function (e) {
    onChange(e);
    changeHandler === null || changeHandler === void 0 || changeHandler(e);
  }, [onChange, changeHandler]);
  return /*#__PURE__*/React.createElement(Group, {
    value: value
  }, /*#__PURE__*/React.createElement(SimpleGrid, {
    gap: 3,
    columns: card || stacked ? options === null || options === void 0 ? void 0 : options.length : 1
  }, options === null || options === void 0 ? void 0 : options.map(function (_ref2) {
    var tooltip = _ref2.tooltip,
        option = _objectWithoutProperties(_ref2, _excluded);

    var ariaDescribedById = getAriaDescribedById(option, name);

    var label = option.label,
        restOption = _objectWithoutProperties(option, _excluded2);

    return /*#__PURE__*/React.createElement(Stack, {
      direction: direction,
      align: align,
      key: "".concat(name, "-option-").concat(option.value)
    }, type === 'switch' && reversed && /*#__PURE__*/React.createElement(OptionLabel, {
      label: label,
      helpText: option.helpText,
      tooltip: tooltip
    }), /*#__PURE__*/React.createElement(Field, _extends({
      as: Input,
      variant: getVariant(card, stacked),
      name: name
    }, restOption, type !== 'switch' && {
      label: label
    }, {
      "aria-describedby": ariaDescribedById,
      justifySelf: "center",
      alignItems: "start",
      isDisabled: option.disabled,
      helpText: option.helpText,
      tooltip: tooltip,
      onChange: function onChange(e) {
        return setField(e);
      }
    })), type === 'switch' && !reversed && /*#__PURE__*/React.createElement(FormLabel, {
      htmlFor: option.id
    }, /*#__PURE__*/React.createElement(OptionLabel, {
      label: label,
      helpText: option.helpText,
      tooltip: tooltip
    })));
  })));
};

OptionsGroup.displayName = "OptionsGroup";
OptionsGroup.displayName = 'OptionsGroup';
export { OptionsGroup };